/**
 * Staff time clock (t1106). A time entry is one shift segment: clock in,
 * clock out. `self` entries come from the staff member's own punch button;
 * `admin` entries were typed in by a manager (a forgotten punch, a correction
 * that replaces an entry).
 */
export const TIME_ENTRY_SOURCES = ['self', 'admin'];
/** Derived, never stored: voided if voided, else open until it has a clock-out. */
export const TIME_ENTRY_STATUSES = ['open', 'closed', 'voided'];
/** An open entry older than this is almost certainly a forgotten clock-out. */
export const LONG_OPEN_SHIFT_HOURS = 16;
//# sourceMappingURL=time-clock.js.map